import React, { useCallback, useMemo, useState } from 'react';
import CustomSideNav from './sidenav';
import useStore from '../store/zustandstore';
import { useLocation } from 'react-router-dom';
import { isPublicIntakePath } from '../api/allowToken';
import { unrestrictedRoutes } from '../permisiions';

const hasStaffToken = () => {
  try {
    return Boolean(window.localStorage.getItem('auth'));
  } catch (e) {
    return false;
  }
};

const SIDENAV_PREF_KEY = 'care.sidenav.collapsed';
const readCollapsedPref = () => {
  try {
    return window.localStorage.getItem(SIDENAV_PREF_KEY) === '1';
  } catch (e) {
    return false;
  }
};
const writeCollapsedPref = (collapsed) => {
  try {
    window.localStorage.setItem(SIDENAV_PREF_KEY, collapsed ? '1' : '0');
  } catch (e) {
    /* private mode / blocked storage: the default (expanded) still works */
  }
};

const SideNavLayout = ({ children }) => {
  // Every page starts with the sidebar EXPANDED (owner 2026-10-07; the
  // redesign had opened on the slim icon rail). A user's own toggle is
  // remembered in this browser; phones always get the rail (sidenav.jsx),
  // and that automatic collapse is not saved as the user's choice.
  const [isCollapsed, setIsCollapsedState] = useState(readCollapsedPref);
  const setIsCollapsed = useCallback((next) => {
    setIsCollapsedState((prev) => {
      const value = typeof next === 'function' ? next(prev) : next;
      // Only the toggle passes an updater; the phone rule passes a plain value.
      if (typeof next === 'function') writeCollapsedPref(value);
      return value;
    });
  }, []);
  const isSidenav = useStore((state) => state.isSidenav);
  const location = useLocation();
  const contentStyle = {
    marginLeft: isCollapsed ? 68 : 240,
    // The rail's collapse toggle is deliberately hung outside the nav
    // (sidenav.jsx, right: -12), so it lands on top of whatever the page renders
    // first. Clear its width here rather than every page working around it.
    paddingLeft: 40,
    transition: 'margin-left 200ms ease',
    minHeight: '100vh',
  };
  const queryParams = useMemo(() => new URLSearchParams(window.location.search), []);
  const allowToken = queryParams.get('allowtoken'); // special flow token
  const sidebarParam = queryParams.get('sb'); // optional codes or SD
  // Public pages never get the staff rail: the patient-intake links
  // (/onboard-odessa|frisco|code, /patient, /patient-enrollment; with or without
  // ?allowtoken=, which the Apache short links stop sending) and any other
  // sign-in-free route opened without a staff sign-in. The rail is staff
  // navigation (Home, Logout, ...) and its Form Inbox badge polls a staff-only
  // route: with no token that is a 401, and api.js's refresh + /login redirect
  // would take a patient off the intake form (sec-DEPLOY.md 0.8).
  const isUnrestricted = unrestrictedRoutes.some((route) => location.pathname.startsWith(route));
  if (isPublicIntakePath(location.pathname) || (isUnrestricted && !hasStaffToken())) {
    return children;
  }
   let showSidebar = isSidenav;
    if (allowToken) {
    // special flow: check sidebar param
    if (sidebarParam) {
      showSidebar = true; 
    } else {
      showSidebar =false; 
    }
  } else {
    // normal flow: show sidebar only if isSidenav
    showSidebar = isSidenav;
  }
  if (!showSidebar) {
    return children;
  }
  
 // /tasks used to get its own grey panel; it now sits on the same near-white
 // canvas as every other page.
 const bgColor = 'bg-[#FAFAF9]';
  return (
    <div className="flex">
      <CustomSideNav isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />
      <div
             className={`flex-grow p-2 md:p-4 min-h-screen min-w-0 ${bgColor}`}
        style={contentStyle}
      >
        {children}
      </div>
    </div>
  );
};

export default SideNavLayout;
